module.exports = __webpack_public_path__ + "img/TermosMenu.99d88e13.png";